
const updateVisibleInvoiceSendEmailModal = {
    namespaced: true,
    state: {
        isShowInvoiceSendEmailModal: false,
    },
    mutations: {
        UPDATE_VISIBLE_INVOICE_SEND_EMAIL_MODAL(state, value) {
            state.isShowInvoiceSendEmailModal = value;
        },
    },
    actions: {
        updateVisibleInvoiceSendEmailModal: function({ commit }, value) {
            commit("UPDATE_VISIBLE_INVOICE_SEND_EMAIL_MODAL", value);
        }
    }
}

export default updateVisibleInvoiceSendEmailModal;
